/*
 * PUNCH COLLECTION CARDS — HOMEPAGE-STYLE IMAGE BLENDING
 *
 * Only changes the image slides.
 * It does NOT touch:
 * - badges
 * - TRY ON
 * - Swatch King
 * - titles
 * - pills
 * - ratings
 * - prices
 * - Add to Cart
 *
 * The technique is the same as the working homepage Best Sellers:
 * each image is copied to the background of its own full-width slide,
 * so Safari blends the image and grey on the SAME element.
 */

(() => {
  'use strict';

  const CARD_SELECTOR =
    'body.template-collection .product-list article.punch-product-card';

  const SLIDER_SELECTOR = '.punch-product-card__slider';
  const SLIDE_CLASS = 'pw-collection-blend-slide';

  function setBackground(slide, img) {
    const source =
      img.currentSrc ||
      img.getAttribute('src');

    if (!source) return;

    slide.style.backgroundImage =
      'url("' + source.replace(/"/g, '\\"') + '")';

    img.dataset.pwCollectionBlendReady = 'true';
  }

  function initialiseSlider(slider) {
    /*
     * Only wrap ORIGINAL direct-child images.
     * Existing wrappers are never wrapped again.
     */
    const images = Array.from(slider.children).filter(
      child => child.tagName === 'IMG'
    );

    images.forEach(img => {
      const slide = document.createElement('span');
      slide.className = SLIDE_CLASS;

      img.parentNode.insertBefore(slide, img);
      slide.appendChild(img);

      setBackground(slide, img);

      /*
       * If a lazy-loaded image resolves to a different currentSrc,
       * refresh the slide background after load.
       */
      img.addEventListener(
        'load',
        () => setBackground(slide, img),
        { passive: true }
      );
    });
  }

  function initialiseCard(card) {
    if (!(card instanceof Element)) return;

    const slider = card.querySelector(SLIDER_SELECTOR);
    if (!slider) return;

    initialiseSlider(slider);
  }

  function initialiseWithin(root) {
    if (!(root instanceof Element || root instanceof Document)) return;

    if (root instanceof Element && root.matches(CARD_SELECTOR)) {
      initialiseCard(root);
    }

    root.querySelectorAll(CARD_SELECTOR).forEach(initialiseCard);
  }

  function start() {
    initialiseWithin(document);

    /*
     * Also initialise collection cards injected later
     * by pagination / reveal / page-2 loading.
     */
    const target =
      document.querySelector('main#main') ||
      document.querySelector('main') ||
      document.body;

    if (!target) return;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node instanceof Element) {
            initialiseWithin(node);
          }
        });
      });
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
